module.exports = new __parcel__URL__("wind.06ed8561.svg").toString();